import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Avatar,
  Box,
  ListItem,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';

import usePrimaryNavStore from '@/components/shared/PrimaryNavDrawer/PrimaryNavStore';
import { useSession } from '@/providers/SessionProvider/SessionProvider';

const PrimaryNavClientCard = () => {
  const theme = useTheme();
  const { isDrawerOpen, setIsClientActionsSubMenuOpen } = usePrimaryNavStore();

  const { currentClient, currentUser } = useSession();

  return (
    <Box
      sx={{
        height: '56px',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <ListItem
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: isDrawerOpen ? 'space-between' : 'center',
          cursor: 'pointer',
        }}
        onClick={() => setIsClientActionsSubMenuOpen(true)}
        data-cy="client-card"
      >
        <Stack
          direction="row"
          spacing={isDrawerOpen ? 0.5 : 0}
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: isDrawerOpen
              ? theme.primaryNav.hoverBackgroundColor
              : 'transparent',
            border: isDrawerOpen ? '1px solid #404E57' : 'none',
            borderRadius: isDrawerOpen ? '30px' : '0',
            transition: `
              background-color 300ms ${theme.transitions.easing.easeInOut},
              border 300ms ${theme.transitions.easing.easeInOut},
              border-radius 300ms ${theme.transitions.easing.easeInOut},
              justify-content 300ms ${theme.transitions.easing.easeInOut}
            `,
            height: '56px',
            flex: 1,
            p: 1,
            '&:hover': {
              '.more-vert-icon': {
                color: 'white',
              },
            },
          }}
        >
          <Avatar
            src={currentClient?.squareLogo ?? ''}
            sx={{
              border: '1px solid #404E57',
              transition: `all 300ms ${theme.transitions.easing.easeInOut}`,
            }}
          />
          {isDrawerOpen && (
            <>
              <Stack
                sx={{
                  opacity: 1,
                  transition: `opacity 300ms ${theme.transitions.easing.easeInOut}`,
                }}
              >
                <Stack sx={{ ml: 0.5 }}>
                  <Tooltip title={currentClient?.displayName}>
                    <Typography
                      variant="subtitle2"
                      color="white"
                      sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: 200,
                      }}
                    >
                      {currentClient?.displayName}
                    </Typography>
                  </Tooltip>
                  <Typography variant="caption" color="grey">
                    {currentUser?.email}
                  </Typography>
                </Stack>
              </Stack>
              <MoreVertIcon
                className="more-vert-icon"
                sx={{
                  color: 'grey',
                  transition: `color 300ms ${theme.transitions.easing.easeInOut}`,
                  '&:hover': {
                    color: 'white',
                  },
                }}
              />
            </>
          )}
        </Stack>
      </ListItem>
    </Box>
  );
};

export default PrimaryNavClientCard;
